import FormatListBulletedIcon from '@material-ui/icons/FormatListBulleted';
import React from 'react';
import styled from 'theme';
import { useTranslation } from 'react-i18next';

const TabIconContainer = styled.span`
    display: flex;
    align-items: center;
    font-size: 14px;
`;

const ListIcon = styled(FormatListBulletedIcon)`
    && {
        font-size: 16px;
        margin-right: 10px;
    }
`;

function StatementsIcon() {
    const { t } = useTranslation();

    return (
        <TabIconContainer>
            <ListIcon />
            {t('common.charting.tabs.statements')}
        </TabIconContainer>
    );
}

export default StatementsIcon;
